import React,{Component} from "react";
// import $ from 'jquery';
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import NewMail from './NewMail';
import ReplyToMail from './ReplyToMail';
import { callGET, callPOST } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {isValidEmail,getUnique} from '../../../Utils/UserFunctions';
import AssignWindow from '../EmailTemplate/AssignWindow';
import {parameterizedURLAccessToken,getSelectedValueBasedOnField,isSet,updateImageSources, revertImageSources, roundOffTwoDecimal } from '../../../Utils/CommonFunctions';import TableModal from '../../../Components/UI/TableModal';
import TableModalMeta from '../../../Components/UI/TableModal';
// import RichTextEditor from 'react-rte';
import DirectoryMapping from './DirectoryMapping';
import ChooseExcelTemplate from "../../LayoutContainer/ChooseExcelTemplate";
import http from "../../../services/http";
// import uuid from "react-uuid";
import { validate as uuidValidate } from 'uuid';
import {FILE_SIZE_ATTACHMENTS_LIMIT} from '../../../Global/Constants';
import FileMapping from "./FileMapping";
import { validRange } from "semver";

const KeyCodes = {
    comma: 188,
    enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

class ComposeMailContainer extends Component {
	constructor(props) {
        super(props);
        this.state = {
            isChooseExcelModelOpen:false,
            excelTemplateList:[],
            excelTemplateId:'',
	        is_system_user: false,
	        modal: false,
	        modalWindow: false,
	        replyToWindow: false,
	        emailConfigList:[],
	        documentList:[],
	        isDirectoryModalOpen:false,
	        documentValue:null,
	        message_group_id:null,
	        formFields:{
	            data_id : {
	                title : "id",
	                field : "hidden",
	                placeHolder : "",
	                value : '',
	                error: '',
	                options : []
	            },
	            window_name : {
	                title : "Scope",
	                window_name_label: "",
	                field : "select",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control mandatory',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []
	            },
	            mail_from : {
	                title : "Mail From",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 border_bottom',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_to : {
	                title : "Mail To",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 newMail_custom',
	                value : [],
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_cc : {
	                title : "Mail CC",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 newMail_custom',
	                value : [],
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_bcc : {
	                title : "Mail BCC",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 border_bottom',
	                value : [],
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_reply_to : {
	                title : "Reply To",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 border_bottom',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_subject : {
	                title : "Mail Subject",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 newMail_custom',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_template : {
	                title : "Mail Template",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 newMail_custom',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_body : {
	                title : "Mail Body",                
	                field : "text",
	                required : false,
	                placeHolder : "",
	                classname : 'form-control no-bd pl-0 border_bottom',
	                value : '',
	                error: '',
	                disabled:false,
	                options : []    
	            },
	            mail_attachments:[],
	            email_config_id:''
	        },
	        mail_templates: [],
	        toInputValue: '',
	        toUsers: [],
	        ccInputValue: '',
	        bccInputValue: '',
	        ccUsers: [],
	        bccUsers: [],
	        suggestions:[],
	        activeUser:null,
	        activeIndex:null,
	        ccShow: false,
	        bccShow: false,
	        triggerEffect: false,
	        emailName: this.props.match.params.emailName,
	        pageType: 'Listing',
	        windowId: (this.props.match.params.windowId!==undefined && this.props.composePage !== 'main') ? this.props.match.params.windowId : '',
	        formId: (this.props.match.params.formId!==undefined) ? this.props.match.params.formId : '',
	        isParamWindow: (this.props.match.params.windowId!==undefined) ? true : false,
	        tableRecords:{            
	            selectedRows:[],
	            tableHead:[],
	            tableData:[],
	            pagination:{
	                page:0,
	                orderBy:'createdAt',
	                perPage:10,
	                direction:'ASC',
	                totalRecords:0,
	                search:'',
	                listId : {
	                    value : ''
	                }
	            }
	        },	        
	        files: [],
	        filesInternal: [],
	        totalFileSize: 0,
	        isFileSizeExceeded: false,
	        windowTags: [],
	        mailData: '',
	        isModalOpen:false,
	        tableAttcahmentsRecords:{
	        	selectedRows:[],	
		          tableHead:[
		          	{
		              name:'',
		              type:"RadioButton",
		              columnId:"",
		              isShow:true
		            },
		          	{
		              name:"PDF Name",
		              type:"Setting",
		              clickHandler:"",
		              isShow:true,
		              attributes:{
		              }
		            },
		            {
		              name:"Description",
		              type:"HyperLink",
		              clickHandler:"",
		              isShow:true,
		              attributes:{
		              }
		            },
		            {
		              name:"Is Active",
		              type:"Status",
		              clickHandler:"",
		              isShow:true
		            },
		            // {
		            //   name:"HTML Content",
		            //   type:"HyperLink",
		            //   clickHandler:"",
		            //   isShow:true,
		            //   attributes:{
		            //   }
		            // },
		          ],
		          tableData:[], 
		          pagination:{
		            page:0,
		            orderBy:'',
		            perPage:5,
		            direction:'ASC',
		            totalRecords:0,
		            search:''
		          }
	        },
	        composePage:this.props.composePage,
	        isModalMetaOpen:false,
	        windowsListData: [],
	        windowNameMeta: '',
	        tableMetaRecords:{
	          tableHead:[],
	          tableData:[], 
	          pagination:{
	            page:0,
	            orderBy:'',
	            perPage:10,
	            direction:'ASC',
	            totalRecords:0,
	            search:''
	          }
	        },
	        lookup_layout:{},
	        selectedMultiLookup:[],
	        attachType: 'PDF',
	        textType: 'markdown' ,
	        replyMessageClose: false,
            getAllUserList:[],
	        filesList: [],
	        isFilesModalOpen: false,   
            isLoader:true
	    }
    }

    componentWillMount = () => {
    	if(this.props.isDraft === false){    		
        	this.windowsList(this.state.tableRecords.pagination);    	
    	}
    	// const userInfo = getUserInfo();
    	// const updateState = { ...this.state };        
     //    updateState.formFields['mail_from'].value= userInfo.data.email;
     //    this.setState(updateState);
        let formId = this.state.formId;
        this.callEmailConfigList();
        this.callDocumentList();
        this.getFilesList();
        if(formId!==undefined && formId!==null && formId!=='' && this.props.isReplyToFromDetailWindow === false){
        	//console.log('000000')
            const updateState = { ...this.state };        
            updateState.windowId= this.props.match.params.windowId;
            this.setState(updateState); 
            this.getToAddressByMetaData();
        }else if(this.props.isDraft === true){
        	//console.log('1111111')

        	this.assignDraftHandler();
        }else if(this.props.isReplyTo === true) {
        	//console.log('222222222')
        	// this.toggleModelHandler();
        	//console.log(this.props.replyToData, 'replyToData==');
        	if(this.props.replyToData) {
        		//console.log(this.props.replyMessageClose, 'replyMessageClose:false===')
        		const updateState = {...this.state}
        		let item = [];
        		let ccUsers = [];
        		let bccUsers = [];
        		if(this.props.replyToData.placeholder === "OUTBOX"){ // To address act as Reply mail 
        			if(this.props.replyToData.more_info){
        				item = JSON.parse(this.props.replyToData.more_info);	
        			}else{
        				item = [{
			                email_address: this.props.replyToData.reply_to,
			                email_field_display_name: this.props.replyToData.reply_to,
			                field_display_name: this.props.replyToData.reply_to,
			                index: 1,
			                metatable_id: ''
			            }]
        			}       			
        		}else{ // From address act as Reply mail
        			item = [{
		                email_address: this.props.replyToData.from,
		                email_field_display_name: this.props.replyToData.from,
		                field_display_name: this.props.replyToData.from,
		                index: 1,
		                metatable_id: ''
		            }]
		            //console.log(this.props.replyToData.to,'tooooooooooooooo');
		            if(this.props.replyToData.to && this.props.replyToData.to.length > 0) {
		            	this.props.replyToData.to.map((toItem,toInd) => {
		            		if(toItem !== this.props.replyToData.emailConfigName){
		            			if(this.props.replyToData.isReplyAll){ // Reply All auto assign to cc users
		            				ccUsers.push({
						                email_address: toItem,
						                email_field_display_name: toItem,
						                field_display_name: toItem,
						                index: toInd+2,
						                metatable_id: ''
						            })	
						            updateState.ccShow = true;
		            			}			            		
		            		}
		            	})
		            }
        		}
        		
        		if(this.props.replyToData.isReplyAll && this.props.replyToData.isReplyAll===true && this.props.replyToData.cc && this.props.replyToData.cc.length > 0) {
	            	this.props.replyToData.cc.map((ccItem,ccInd) => {
	            		if(ccItem !== this.props.replyToData.emailConfigName) {
		            		ccUsers.push({
				                email_address: ccItem,
				                email_field_display_name: ccItem,
				                field_display_name: ccItem,
				                index: ccInd+1,
				                metatable_id: ''
				            })
	            		}
	            	})
	            	updateState.ccShow = true;
	            }

	            updateState['toUsers'] = item;
	            updateState['ccUsers'] = ccUsers;

	            updateState.formFields['mail_subject'].value = this.props.replyToData.subject;
	            updateState.formFields['email_config_id'] = this.props.replyToData.email_config_id;
	            updateState.formFields['mail_from'].value = this.props.replyToData.emailConfigName;

	            // updateState.formFields['mail_body'].value = this.props.replyToData.body;
	            updateState.message_group_id = this.props.replyToData.message_group_id;
	            updateState.replyToWindow = !this.state.replyToWindow;	       

	            this.setState(updateState)
        	}
        }else if(this.props.isReplyToFromDetailWindow){
        	       	
        	if(this.props.replyToData) {
        		const updateState = {...this.state}
        		let item = [];
        		if(this.props.replyToData.placeholder === "OUTBOX"){ // To address act as Reply mail 
        			if(this.props.replyToData.more_info){
        				item = JSON.parse(this.props.replyToData.more_info);	
        			}else{
        				item = [{
			                email_address: this.props.replyToData.reply_to,
			                email_field_display_name: this.props.replyToData.reply_to,
			                field_display_name: this.props.replyToData.reply_to,
			                index: 1,
			                metatable_id: ''
			            }]
        			}        			        		
        		}else{ // From address act as Reply mail
        			item = [{
		                email_address: this.props.replyToData.from,
		                email_field_display_name: this.props.replyToData.from,
		                field_display_name: this.props.replyToData.from,
		                index: 1,
		                metatable_id: ''
		            }]
        		}	            
	            updateState['toUsers'] = item;
	            updateState.formFields['mail_subject'].value = this.props.replyToData.subject;
	            updateState.formFields['email_config_id'] = this.props.replyToData.email_config_id;

	            // updateState.formFields['mail_body'].value = this.props.replyToData.body;
	            updateState.message_group_id = this.props.replyToData.message_group_id;	            
	            this.setState(updateState)

        	}
        	setTimeout(() => { this.toggleModelHandler(); }, 500); 
        }else{        	
       		this.toggleModelHandlerWindow();         	               	
        }
        this.tagMappingList();
    }

	componentDidUpdate = (nextProps, prevProps) =>{
		// console.log('componentDidUpdate',nextProps.replyMessageClose,this.state.replyMessageClose)
        //console.log('replyMessageClose==',nextProps.replyMessageClose,this.props.replyMessageClose)
        if(nextProps.replyMessageClose!==this.props.replyMessageClose){

        	if(this.props.replyMessageClose){
        		const updateState = {...this.state}		    
		        updateState['toUsers'] = [];
		        updateState.formFields['mail_subject'].value = '';
		        updateState.formFields['mail_body'].value = '';
		        updateState.replyToWindow = false;
		        this.setState(updateState)	
        	}
         	 
        }
        
    }    
    addSize = (data = []) => {
        return data.reduce((sum, f) => {
            const kb = f?.size ? f.size / 1000 : 0;
            return sum + Number(roundOffTwoDecimal(kb)) || 0;
        }, 0);
    };

    totalSizeHandler = (files1 = [], files2 = [], documentValue = null) => {
        const size1 = this.addSize(files1);
        const size2 = this.addSize(files2);

        const documentSizeKB = documentValue?.size
            ? Number(roundOffTwoDecimal(documentValue.size / 1000))
            : 0;

        return size1 + size2 + documentSizeKB;
    };


    toggleReplyToWindow = () => {
    	const updateState = {...this.state}
    	if(this.state.replyToWindow) {
        	this.props.composeMailHandler('',this.props.replyToData); 
        }
        updateState['toUsers'] = [];
        updateState.formFields['mail_subject'].value = '';
        updateState.formFields['mail_body'].value = '';
        updateState.replyToWindow = !this.state.replyToWindow;
        this.setState(updateState)
    }

    callEmailConfigList = () => {
        let APIURL = 'email/config/search?smtp_active=true';
        callGET(APIURL)                                     
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null){
                        this.setState({emailConfigList:response.data});
                    }
                }
            }           

        },(error) => {
            console.log(error);
        })
    }

    getToAddressByMetaData = () => {
        this.toggleModelHandler()        
        let windowId = this.state.windowId;        
        const metatableId = (this.props.metaDataId === undefined) ? null : this.props.metaDataId ;
        const API_Url = 'email/message/'+windowId+'/email-addresses?searchText=&metatableId='+metatableId
        callGET(API_Url)
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    const responseData = response.data;
                    let updatedUsers = Object.entries(responseData).map((itemMeta,index)=>{
                        itemMeta[1].map((item, ii) => {
                            // if ( item.email_field_display_name === 'Email'){
                            	item.field_display_name = item.email_address;
                                this.handleAddition(item);        
                            // }                             
                              
                        })                    
                      })

                    this.tagMappingList();
                   	this.templateListAPI(); 
                }
            }
        })
        .catch(err => {
            console.log(err);
        }) 

    }

    toggleModelHandler = () => {
        let updateState = { ...this.state };
        if(this.state.modal) {
        	this.props.composeMailHandler();        
        }
        updateState.modal = !this.state.modal;
        this.setState(updateState);
    }

    continueHandler = () => {
        this.toggleModelHandlerWindow();
        setTimeout(() => { this.toggleModelHandler(); }, 500);  
    }

    toggleModelHandlerWindow = (cancel="no") => {
        let updateState = { ...this.state }; 
        if(cancel === 'yes'){
        	this.props.composeMailHandler();	
        }       
        if(!this.state.modalWindow) {
            //updateState = this.clearFormFields(updateState);
        }
        updateState.modalWindow = !this.state.modalWindow;
        this.setState(updateState); 
        this.templateListAPI(); 
        this.tagMappingList();
        this.getUserListHandler(); 
        this.pdfCreationList(this.state.tableAttcahmentsRecords.pagination);     
    }

    //clear fields
    clearFormFields = (updateState) => {
        //const updateState = { ...this.state };        
        //updateState.formFields['mail_from'].value= '';
        let formId = this.state.formId;
        updateState.formFields['data_id'].value= '';
        let windowsList = updateState.formFields['window_name'].options;
        updateState.formFields['window_name'].value= windowsList[0].value;
        updateState.formFields['window_name'].window_name_label= windowsList[0].name;
        if(this.props.match.params.windowId===undefined){
            updateState.windowId = windowsList[0].value;   
            updateState.isParamWindow = false;   
        }
        updateState.formFields['mail_to'].value= [];
        updateState.formFields['mail_cc'].value= '';
        updateState.formFields['mail_bcc'].value= '';
        updateState.formFields['mail_reply_to'].value= '';        
        updateState.formFields['mail_subject'].value= '';
        updateState.formFields['mail_template'].value= '';        
        updateState.formFields['mail_body'].value= '';
        updateState.triggerEffect = !this.state.triggerEffect;        
        updateState.ccInputValue = '';
        updateState.bccInputValue = '';
        updateState.ccUsers= [];
        updateState.bccUsers= [];
        updateState.toInputValue = '';        
        if(!formId){
            updateState.toUsers= [];            
        }
        updateState.suggestions= [];
        updateState.files= [];
        updateState.filesInternal= [];
        updateState.totalFileSize= 0;
        updateState.isFileSizeExceeded= false;
        updateState.windowTags= [];
        return updateState;
    }

    ccToggleHandler = () => {
        const updateState = { ...this.state }; 
        updateState.ccShow = !this.state.ccShow;
        this.setState(updateState);  
    }

    bccToggleHandler = () => {
        const updateState = { ...this.state }; 
        updateState.bccShow = !this.state.bccShow;
        this.setState(updateState);  
    }

    // On change event for form fields general.
    addDataHandler = async (event) => {                
        const { name, value, options, selectedIndex } = event.target;        
        const updateState = { ...this.state };        
        updateState.formFields[name].value= value;
        updateState.formFields[name].error= '';
        updateState.autoFocusElement = 'subject'; 
        if(name==='window_name' && (this.props.match.params.windowId===undefined || this.props.composePage === 'main')){
            updateState.windowId = value;   
        }
        if(name === 'mail_from') {
        	updateState.formFields['email_config_id']= event.target.selectedOptions[0].getAttribute("confid");
        }  
        this.setState(updateState);
        if(name==='window_name'){
            //this.templateListAPI();
            await this.tagMappingList();  
            await this.getUserListHandler(); 
        }
                
    }

    addDataTemplateBody = (bodyVal) => {
        const updateState = { ...this.state };
        updateState.formFields['mail_body'].value= bodyVal;
        this.setState(updateState);
    }

    // call method for to get template id
    callTemplateData = (event) => {
        const { name, value, options, selectedIndex } = event.target;        
        if(value!=='' && value!==null){
            const updateState = { ...this.state };        
            updateState.formFields['mail_template'].value= value;
            updateState.formFields['mail_template'].error= '';                
            this.setState(updateState);
            this.getTemplateData(this.state.formFields.mail_template.value);
        }
    }

    // call method to get template data.
    getTemplateData = async (templateID) => {
        //let windowId = '69dea0d7-fef6-45ef-b443-32f83c2fc9b6';
        let windowId = this.state.windowId;
        //let templateID = templateID;
        const mail_to = this.state.toUsers;        
        let metaIds = ''; 
        if(mail_to.length>0){
            metaIds = mail_to.map( (a, i) => `&metaDataIds=${isSet(a.metatable_id,'')}`).join('');                                
        }

        if(this.state.composePage === 'metadata') {
        	metaIds = '&metaDataIds='+this.state.formId;
        }
        this.props.Loader(true);
        const url = 'email/message/prepare?eMailTemplateId='+templateID+'&windowId='+windowId+metaIds;
        callGET(url)
        .then(res => {            
            if(res.status===200){ 
                this.props.Loader(false);
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null){
                        const updateState = { ...this.state };
                        if(response.data.body!==null){
                            updateState.formFields['mail_body'].value= updateImageSources(response.data.body);
                            updateState.formFields['mail_subject'].value= response.data.subject;
                            updateState.triggerEffect = !this.state.triggerEffect; 
                            //console.log('response.data.body',response.data.body)
                           
                            //this.setState({formFields:{...this.state.formFields,mail_body:{...this.state.formFields.mail_body,value:response.data.body},mail_subject:{...this.state.formFields.mail_subject,value:response.data.subject}},triggerEffect:!this.state.triggerEffect});
                            //this.updateStateValues(response);
                        }else{
                            updateState.formFields['mail_body'].value= '';
                            updateState.formFields['mail_subject'].value= '';
                            updateState.triggerEffect = !this.state.triggerEffect; 
                            //this.setState(updateState);   
                        }      
                        this.setState(updateState);                                              
                    }                      
                }
            }else{
                this.props.Loader(false);
                this.props.failMessage('Something went wrong!!!');    
            }
           
        },(error) => {
            this.props.Loader(false);
            this.props.failMessage('Something wrong on Action Button Listing!!!');
            console.log(error);
        })
    }
    // updateImageSources=(body)=>{
    //     let imageIds = body.match(/[^#SIMG(\}]+(?=\))/g);
    //     if(imageIds.length>0){
    //         imageIds.map((image)=>{
    //             if(isValidUUID(image)){
    //                 try{
    //                     let ImageData = ShipConstants.API_URL+'files/download?fileId='+image; 
    //                     if(ImageData!==null){
    //                         body = body.replace('cid:#SIMG('+image+')', ImageData);
    //                     }
                        
    //                 }catch(error){
    //                     console.error("error",error);
    //                 }    
    //             }
    //         })
    //     }
    //     return body;
    // }
    // revertImageSources = (body)=>{
    //     let imageIds = body.match(/(?<=fileId=)(.*?)(?=")/g);
    //     if(imageIds.length>0){
    //         imageIds.map((image)=>{
    //             if(isValidUUID(image)){
    //                 body = body.replace(ShipConstants.API_URL+'files/download?fileId='+image+'"', "cid:#SIMG("+image+")\"");    
    //             }
    //         })
    //     }
    //     return body;
    // }

    updateStateValues = (response) => {
    	const updateState = { ...this.state };
    	updateState.formFields['mail_body'].value= response.data.body;
        updateState.formFields['mail_subject'].value= response.data.subject;
        updateState.triggerEffect = !this.state.triggerEffect; 
        this.setState(updateState);
    }

    // filter template by tags method
    filterTemplateByTagHandler = (event) => {
        const { name, value, options, selectedIndex } = event.target;        
       	this.templateListAPI(value);
    }
    
    uploadFileAPICall= (files)=>{
         
        Object.entries(files).map(([key, fileItem]) => {
            const formData = new FormData();            
            formData.append("upload_file", fileItem);
            const APIURL = 'files/upload';
            callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
            .then(res => {    
                if(res.status==200){                        
                    const response = res.data;
                  if(response.code===200){
                      const responseData =  response.data;
                      let filesArr = this.state.files;
                      filesArr.push({
                        id:responseData,
                        value:responseData,
                        checked:null,
                        file:fileItem,
                        label:fileItem.name,
                        size:fileItem.size
                      });
                      const totalSize =this.totalSizeHandler(filesArr,this.state.filesInternal,this.state.documentValue)
                      const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
                        this.setState({files:filesArr, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});                      
                    }else{
                        this.setState({files:[]}); 
                        this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
                    }                                                
                }else{
                    this.setState({files:[]});                     
                    this.props.failMessage('Something went wrong..');
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({files:[]}); 
                this.props.failMessage('Something went wrong..');                    
            })
        })
          
    }

    removeAddedFile = (Fileindex) => {
        let updateFiles = this.state.files;
        updateFiles = updateFiles.filter((item,index)=>{
            if(index!== Fileindex){
              return item;
            }
        })
        const totalSize = this.totalSizeHandler(updateFiles,this.state.filesInternal,this.state.documentValue);
        const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
        this.setState({files:updateFiles, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});        
    }
    
    removeAddedFileInternal = (Fileindex) => {
        let updateFiles = this.state.filesInternal;
        updateFiles = updateFiles.filter((item,index)=>{
            if(index!== Fileindex){
              return item;
            }
        })
        const totalSize = this.totalSizeHandler(this.state.files, updateFiles, this.state.documentValue);
        const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
        this.setState({filesInternal:updateFiles, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});        
    }

    setIsFileSizeExceeded = (isExceeded) => {
        this.setState({isFileSizeExceeded: isExceeded});
    }

    removeAddedFileDocument = () => {
        const totalSize = this.totalSizeHandler(this.state.files, this.state.filesInternal);
        const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
        this.setState({documentValue:null,totalFileSize: totalSize, isFileSizeExceeded: isExceeded});        
    }

    callDownloadImgFile = (itemFile) => {
        document.location.href = parameterizedURLAccessToken('files/download?fileId='+itemFile.id);        
    }

    // call method to save action button
    saveDataHandler = (isReplyTo=false,bodycontent='') => {
        
        const fileInput = document.querySelector("#fileInput");
        const formData = new FormData();
        if(fileInput) {
	        if(fileInput.files){
		        if(fileInput.files.length>0){
		            Object.entries(fileInput.files).map((files, index) => {
		                formData.append("attachments", fileInput.files[index]);   
		            })
		        }        
	    	}
    	}

        //return false;
        const header = { 'Content-Type': 'application/json' }
        let body = '';
        const mail_from = this.state.formFields.mail_from.value;
        //const mail_to = this.state.formFields.mail_to.value;
        const mail_to = this.state.toUsers;
        const mail_cc = this.state.ccUsers;
        const mail_bcc = this.state.bccUsers;
        // const mail_reply_to = this.state.formFields.mail_reply_to.value;
        const mail_subject = this.state.formFields.mail_subject.value;
        let mail_body = bodycontent && bodycontent!=='' ? bodycontent : this.state.formFields.mail_body.value;//bodycontent;
        const attachments = this.state.files;
        const attachmentsInternal = this.state.filesInternal;
        const email_config_id = this.state.formFields.email_config_id;
        const message_group_id = this.state.message_group_id;
        const documentValue = this.state.documentValue;
        // console.log(mail_body,'mail_body==')
        // return false;
        //mail_body = '<p><p>Hello ${Lead.first_name} ${Lead.last_name},</p> <p><br></p> <p>This is to inform you that please login to <a href="https://shipcrm.org/" target="_blank">ShipCRM</a> and check your email.</p> <p><br></p> <p>Thanks &amp; Regards,</p> <p>Team ShipCRM</p></p>';
        //mail_body = '<div>&lt;!DOCTYPE html&gt;</div><div>&lt;html&gt;</div><div>&lt;body&gt;</div><div><br></div><div>&lt;p&gt;This is a paragraph.&lt;/p&gt;</div><div>&lt;p&gt;This is a paragraph.&lt;/p&gt;</div><div>&lt;p&gt;This is a paragraph.&lt;/p&gt;</div><div><br></div><div>&lt;/body&gt;</div><div>&lt;/html&gt;</div>';
        //mail_body = "<!DOCTYPE html><html><body><p>This is a paragraph.</p><p>This is a paragraph.</p><p>This is a paragraph.</p></body></html>";
        const updateState = { ...this.state };
        let chkValid = true;

        // Check file size limit (25 MB)
        if (this.state.totalFileSize > FILE_SIZE_ATTACHMENTS_LIMIT) {
            this.props.failMessage(`Total attachment size exceeds the ${(FILE_SIZE_ATTACHMENTS_LIMIT / 1024)} MB limit`);
            return false;
        }

        // console.log(mail_from,'mail_from===',mail_subject); 
        // return false;

        if(mail_from===''){                            
            updateState.formFields['mail_from'].error= 'From Address field should not be Empty'; 
            chkValid = false;            
        }

        if(mail_to.length<1){                            
            updateState.formFields['mail_to'].error= 'To Address field should not be Empty'; 
            chkValid = false;            
        }else{
            updateState.formFields['mail_to'].error= '';         	
        }

        if(mail_subject===''){                            
            updateState.formFields['mail_subject'].error= 'Subject field should not be Empty'; 
            chkValid = false;            
        }        
        this.setState(updateState);

        if(chkValid===false){
            return false;
        }

        this.props.Loader(true);

        const formData1 = new FormData(); 
        const fileInput1 = document.querySelector("#fileInput");
        // let filesArr = []  
        if(fileInput1){
	        if(fileInput1.files){     
		        if(fileInput1.files.length>0){
		            Object.entries(fileInput1.files).map((files, index) => {
		            })
		        }
	    	}
    	}

        let attachmentsAll = [];        
        attachments.forEach((files, index) => {
            attachmentsAll.push(files.id)            
        })
             
        attachmentsInternal.forEach((files, index) => {            
            attachmentsAll.push(files.id)
        })        
        formData1.append('attachment_file_ids', attachmentsAll);


        let allTo = [];
        let more_info = [];
        let metaIds = [];

        let mail_to_final = getUnique(mail_to, 'email_address');

        mail_to_final.forEach((toemail, index) => {
            allTo.push(toemail.email_address);
            if(toemail.metatable_id!==''){
                metaIds.push(toemail.metatable_id);
            }
            toemail.window_id = this.state.windowId;
            more_info.push(toemail);
        }) 

        let allCc = [];        
        mail_cc.forEach((toemail, index) => {
            allCc.push(toemail.email_address);            
        })

        let allBcc = [];        
        mail_bcc.forEach((toemail, index) => {
            allBcc.push(toemail.email_address);            
        })

        formData1.append("body", revertImageSources(mail_body));
        formData1.append("subject", mail_subject);
        formData1.append("from", mail_from);
        formData1.append("to", allTo);
        formData1.append("cc", allCc);
        formData1.append("bcc", allBcc);
        formData1.append("metadata_ids", metaIds);
        formData1.append("more_info", JSON.stringify(more_info));
        formData1.append("email_config_id", email_config_id);
        formData1.append("message_group_id", message_group_id);
        formData1.append("directory", JSON.stringify(documentValue));
        formData1.append("metadataId", this.props.match.params.page === "detailView" ? this.props.metaDataId :'');

        if(this.state.formFields.data_id.value!==''){
            formData1.append("id", this.state.formFields.data_id.value);
        }

        let APIURL = 'email/message/send';
        callPOST(APIURL,formData1,header)
        .then(response => {                
            this.props.Loader(false);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
            	if(isReplyTo === true) {
            		this.toggleReplyToWindow();
            		this.props.emailMessageList(this.state.tableRecords.pagination);
            	}else {
            		this.toggleModelHandler();
	                if(this.state.composePage === 'main'){
	                	this.props.emailMessageList(this.state.tableRecords.pagination);
	                }else if(this.state.composePage === 'metadata'){
	                	this.props.emailMessageList();
	                }
            	}             
                
                this.props.succMessage(responseData.message);                
            }else {  

            	const violations = responseData.violations;
	          	let validationMsgArr = [];
	          	violations.map((fields)=>{
	            	validationMsgArr.push(fields.message);
	          	});
	          	if(validationMsgArr.length===0){
	            	this.props.failMessage(responseData.message);
	          	}else{
	            	this.props.failMessage(validationMsgArr.join('</br>'));
	          	}

                //this.props.failMessage(responseData.message);
            }
        })
        .catch(err => {
            this.props.Loader(false);
            this.props.failMessage("Something Went Wrong");
            console.log(err);
        })
    }

    //Windows List
    windowsList = (pagination) => {
        const page = pagination.page; 
        const orderBy = pagination.orderBy; 
        const perPage = pagination.perPage; 
        const direction = pagination.direction; 
        const search = pagination.search;
        this.setState({
        tableRecords:{
            ...this.state.tableRecords,
            pagination:pagination
        }
        });
        const queryString = '?query='+search+'&page='+page+'&orderBy=display_name&size=10000000&direction='+direction;
        callGET("windows/list"+queryString)
        .then(res => {
            const response = res.data;
            let windowsList = [];
            if(response.code===200){
            response.data.windows.content.map((arr,i) => {
                const value = {
                "label": arr.display_name,
                "name": arr.display_name,
                "value": arr.id,
                "windowName": arr.window_name
                }
                windowsList.push(value);
            })
            }
            if(windowsList.length > 0) {
                const updateState = { ...this.state };
                updateState.formFields['window_name'].options= windowsList;
                updateState.formFields['window_name'].value= windowsList[0].value;
                updateState.formFields['window_name'].window_name_label= windowsList[0].name;
                if(this.props.match.params.windowId===undefined || this.props.composePage === 'main'){
                    updateState.windowId = windowsList[0].value;
                    updateState.isParamWindow = false;   
                } 
                updateState.windowsListData = response.data.windows.content; 
                this.setState(updateState);
                this.templateListAPI();
        		this.pdfCreationList(this.state.tableAttcahmentsRecords.pagination);     

            }
            
        }, (error) => {
            console.log(error);
        });
    }

    // call method for template list
    templateListAPI = (tagId = '') => {
        let windowId = this.state.windowId;
        let extraParam = '';
        if(tagId!==''){
            extraParam = '&tag_ids='+tagId;
        }
        const url = "email/template/search?window_id="+windowId+extraParam;        
        callGET(url)
        .then(res => {
            
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null && response.data!==undefined){
                        let templateData = response.data.content.map((item,index)=>{                                                        
                            return {                                
                                name: item.name,
                                value: item.id                              
                            }
                        })                        
                        this.setState({mail_templates: templateData});

                    }else{
                        this.setState({mail_templates: []});   
                    }                       
                }else{
                    this.setState({mail_templates: []});
                }
            }else{
                this.props.failMessage('Something went wrong!!!');    
            }
        },(error) => {
            this.props.failMessage('Something went wrong!!!');
            console.log(error);
        })
    }

    // tags list based on window
    tagMappingList = () => {
        let windowId = this.state.windowId;        
        const API_Url = 'tag-mapping/window/'+windowId
        callGET(API_Url)
        .then(res => {
            if(res.status===200){ 
            const response = res.data;
            if(response.code===200){
                const responseData = response.data;
                
                let windowTags = [];
                let updateSugestion = [];
                let updatedTags = responseData.map((item,index)=>{
                    windowTags.push(item)                    
                    return item;
                  })
                
                this.setState({windowTags:windowTags})                
            }
            }
        })
        .catch(err => {
            console.log(err);
        }) 
    }

    //call method for to get all user list
    getUserListHandler = () => {
    	const updateState = { ...this.state };
    	let windowId = this.state.windowId;
    	if(windowId!==''){
    		const API_Url = 'email/message/'+windowId+'/email-addresses?searchText=&metatableId=';
	    	callGET(API_Url)
	        .then(res => {
	            if(res.status===200){ 
	                const response = res.data;
	                if(response.code===200){
	                    const responseData = response.data;
	                    let getAllUserList = isSet(responseData.email_message,[]);
	                    //console.log('getUserListHandler responseData===',responseData)
	                    let updateSugestion = [];
	                    if(getAllUserList.length>0){
	                    	getAllUserList.map((item,n)=>{
	                    		updateSugestion.push({
                                    metatable_id:item.metatable_id,
                                    field_display_name:item.field_display_name,
                                    index:n,
                                    email_field_display_name:item.email_field_display_name,
                                    email_address:item.email_address,                            
                                })
	                    	})
	                    }	                    
	                    this.setState({getAllUserList:getAllUserList,suggestions:[]})
	                }else{
	                    this.setState({getAllUserList:[],suggestions:[]})
	                }
	            }
	        })
	        .catch(err => {
	            console.log(err);
	        })	
    	}    	
    }

    // call method of user search list
    searchUserHander = (event) => {
        const { name, value, options, selectedIndex } = event.target;  
        const updateState = { ...this.state };
        updateState.toInputValue = value;
        //this.setState(updateState);
        let getSuggestions = [];
        getSuggestions = this.state.getAllUserList.filter(function(v,i) {
            if(v.email_address.toLowerCase().indexOf(value) >=0 || v.field_display_name.toLowerCase().indexOf(value) >=0) {
                return true;
            }else{
            	return false;
            }
        });
        this.setState({toInputValue:value,suggestions:getSuggestions})
        //console.log('getSuggestions==',getSuggestions);
        
        // let windowId = this.state.windowId;
        // let metatableId = this.state.formId;
        // const API_Url = 'email/message/'+windowId+'/email-addresses?searchText='+value+'&metatableId='
        // callGET(API_Url)
        // .then(res => {
        //     if(res.status===200){ 
        //         const response = res.data;
        //         if(response.code===200){
        //             const responseData = response.data;
        //             let addedUsers = [];
        //             this.state.toUsers.map((item)=>{
        //                 addedUsers.push(item.email_address);                        
        //             })
        //             // console.log(this.state.toUsers)
        //             let updateSugestion = [];
        //             var n = 0;
        //             let updatedUsers = Object.entries(responseData).map((itemMeta,index)=>{
        //                 itemMeta[1].map((item, ii) => {
        //                     if ( addedUsers.indexOf(item.email_address) === -1 ){
        //                         updateSugestion.push({
        //                             metatable_id:item.metatable_id,
        //                             field_display_name:item.field_display_name,
        //                             index:n,
        //                             email_field_display_name:item.email_field_display_name,
        //                             email_address:item.email_address,                            
        //                         })
        //                     } 
        //                     n++;  
        //                     return item;  
                              
        //                 })                    
        //               })
        //             //console.log(updateSugestion,responseData);
        //             updateSugestion = updateSugestion.slice(0,10);
        //             this.setState({suggestions:updateSugestion})
        //         }else{
        //             this.setState({suggestions:[]})
        //         }
        //     }
        // })
        // .catch(err => {
        //     console.log(err);
        // })   
    }

    handleOnBlur = () =>{
        setTimeout(()=>{
            this.setState({suggestions:[]})
        },200)
    }

    blurHandle = (event) => {
    	this.createToUsers(event,true);
    }

    handleKeyDown = (event) => {        
     	this.createToUsers(event);   
    }

    createToUsers = (event,enter=false) => {   
    	let isEmailValid = false; 
        const {metaDataId} = this.props;
    	if(enter === true){
            const updateState = { ...this.state };
            let toInputValue = updateState.toInputValue; 
            if(isValidEmail(toInputValue)){
            	isEmailValid = true;	
            }
            if(toInputValue.trim()!==''){            	
            	const item = {
	                email_address: toInputValue,
	                email_field_display_name: toInputValue,
	                field_display_name: toInputValue,
	                index: 1,
	                metatable_id: uuidValidate(this.state.formId) ? this.state.formId : metaDataId,
	                isValid:isEmailValid
	            }
	            this.handleAddition(item);
            }            
    	}else{
    		if (delimiters.indexOf(event.keyCode) !== -1 ) {
	            const updateState = { ...this.state };
	            let toInputValue = updateState.toInputValue; 
	            if(isValidEmail(toInputValue)){
	            	isEmailValid = true;	
	            }	            
	            if(toInputValue.trim()!==''){ 
		            const item = {
		                email_address: toInputValue,
		                email_field_display_name: toInputValue,
		                field_display_name: toInputValue,
		                index: 1,
		                metatable_id: uuidValidate(this.state.formId) ? this.state.formId : metaDataId,
		                isValid:isEmailValid
		            }
		            this.handleAddition(item);
		        }
	        }	
    	}
    }

    handleAddition = (tomail) => {
        this.setState((state) => ({
            toUsers: [...state.toUsers, tomail],
            suggestions: [],
            toInputValue: '',
            formFields: {
              ...state.formFields,
              mail_to: { ...state.formFields.mail_to, error: '' },
            },
          }));
          
          const templateID = this.state.formFields.mail_template?.value;
          
          if (this.state.composePage === 'metadata') {
            return false;
          }
          
          if (templateID) {
            // setTimeout(() => {
              this.getTemplateData(templateID);
            // }, 200);
          }     
    }

    handleDelete = (i) => {
        const { toUsers, suggestions } = this.state;
        let removeUser = toUsers.filter((user, index) =>{
            if(index !== i){
                return user;
            }
        });
        
        this.setState({
          toUsers: removeUser,
          suggestions: [],
        });
    }

    ccSearchUserHander = (event) => {
        const { name, value, options, selectedIndex } = event.target;  
        const updateState = { ...this.state };
        updateState.ccInputValue = value;
        this.setState(updateState);   
    }
    ccHandleKeyDown = (event) => {        
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            const updateState = { ...this.state };
            let ccInputValue = updateState.ccInputValue; 
            let isEmailValid = false; 
            if(ccInputValue.trim()!==''){
            	if(isValidEmail(ccInputValue)){
	            	isEmailValid = true;	
	            }
            	const item = {
	                email_address: ccInputValue, 
	                isValid:isEmailValid              
	            }
	            this.setState((state) => ({ ccUsers: [...state.ccUsers, item], ccInputValue: '' }));
            }            
        }
    }

    handleDeleteccUSer = (i) => {
        const { ccUsers } = this.state;
        let removeUser = ccUsers.filter((user, index) =>{
            if(index !== i){
                return user;
            }
        });
        
        this.setState({
          ccUsers: removeUser
        });
    }

    bccSearchUserHander = (event) => {
        const { name, value, options, selectedIndex } = event.target;  
        const updateState = { ...this.state };
        updateState.bccInputValue = value;
        this.setState(updateState);   
    }
    bccHandleKeyDown = (event) => {        
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            const updateState = { ...this.state };
            let bccInputValue = updateState.bccInputValue;
            let isEmailValid = false; 
            if(bccInputValue.trim()!==''){
            	if(isValidEmail(bccInputValue)){
	            	isEmailValid = true;	
	            }
            	const item = {
	                email_address: bccInputValue,
	                isValid:isEmailValid                
	            }
	            this.setState((state) => ({ bccUsers: [...state.bccUsers, item], bccInputValue: '' }));
            }            
        }
    }

    handleDeletebccUser = (i) => {
        const { bccUsers } = this.state;
        let removeUser = bccUsers.filter((user, index) =>{
            if(index !== i){
                return user;
            }
        });
        
        this.setState({
          bccUsers: removeUser
        });
    }
    // Endss


    /*********** Draft section ******************/
    saveDraftHandler = () => {
        const header = { 'Content-Type': 'application/json' }
        let body = '';
        const mail_from = this.state.formFields.mail_from.value;
        const data_id = this.state.formFields.data_id.value;
        const mail_to = this.state.toUsers;
        const mail_cc = this.state.formFields.mail_cc.value;
        const mail_bcc = this.state.formFields.mail_bcc.value;
        const mail_reply_to = this.state.formFields.mail_reply_to.value;
        const mail_subject = this.state.formFields.mail_subject.value;
        const mail_body = this.state.formFields.mail_body.value;
        const attachments = this.state.files;
        const attachmentsInternal = this.state.filesInternal;
        const email_config_id = this.state.formFields.email_config_id;


        let param = '';
        param = '?body='+mail_body+'&subject='+mail_subject+'&from='+mail_from


        const formData1 = new FormData(); 
        const fileInput1 = document.querySelector("#fileInput");
        let filesArr = [];

        let attachmentsAll = [];
        let attachmentsArr = [];
        attachments.map((files, index) => {
            attachmentsAll.push(files.id)
            attachmentsArr.push(files.id)
        })

        let attachmentsInternalArr = [];        
        attachmentsInternal.map((files, index) => {
            attachmentsInternalArr.push(files.id)
            attachmentsAll.push(files.id)
        })        
        formData1.append('attachment_file_ids', attachmentsAll);

        let more_info = [];
        more_info.push({"windowId":this.state.windowId})
        more_info.push({"attachments":attachmentsArr})
        more_info.push({"attachmentsInternal":attachmentsInternalArr})

        let allTo = [];        
        mail_to.map((toemail, index) => {
            allTo.push(toemail.email_address);
            more_info.push(toemail);

        })  


        //Check Draft come as empty
        let chkValid = false;
        if(allTo.length>0 || mail_subject!=='' || mail_body!=='' || attachmentsAll.length>0){                                        
            chkValid = true;            
        }       

        if(chkValid===false){
        	this.props.failMessage('Draft not should be empty!!!');
            return false;
        }

        // Check file size limit (20 MB)
        if (this.state.totalFileSize > FILE_SIZE_ATTACHMENTS_LIMIT) {
            this.props.failMessage(`Total attachment size exceeds the ${(FILE_SIZE_ATTACHMENTS_LIMIT / 1024)} MB limit`);
            return false;
        }

        formData1.append("body", mail_body);
        formData1.append("subject", mail_subject);
        formData1.append("from", mail_from);
        formData1.append("to", allTo);
        formData1.append("placeholder", 'DRAFT');
        formData1.append("status", 'DONE');
        formData1.append("more_info", JSON.stringify(more_info));
        formData1.append("email_config_id", email_config_id);
        
        if(data_id!== ''){
            formData1.append("id", data_id);
        }
        
        let APIURL = 'email/message/save';
        callPOST(APIURL,formData1,header)
        .then(response => {                
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
                if(this.state.composePage === 'main'){
                	this.props.emailMessageList(this.state.tableRecords.pagination);
                }      
                this.toggleModelHandler();                    
                this.props.succMessage(responseData.message);                
            }else {    

            	const violations = responseData.violations;
	          	let validationMsgArr = [];
	          	violations.map((fields)=>{
	            	validationMsgArr.push(fields.message);
	          	});
	          	if(validationMsgArr.length===0){
	            	this.props.failMessage(responseData.message);
	          	}else{
	            	this.props.failMessage(validationMsgArr.join('</br>'));
	          	}

                //this.props.failMessage(responseData.message);
                this.toggleModelHandler();
            }
        })
        .catch(err => {
            this.props.Loader();
            this.props.failMessage("Something Went Wrong");
            console.log(err);
        })
        
    }

    assignDraftHandler = (mailData = this.props.mailData) => {

        let updateState = { ...this.state };
        let toUsersArr = [];
        if( mailData && mailData.more_info && mailData.more_info!=='' ){            
            let more_info = JSON.parse(mailData.more_info);            
            more_info.map((info, index) => {
                
                if(index === 0){ // for window                    
                    updateState.formFields.window_name.value = info.windowId;
                    if(this.props.match.params.windowId===undefined){
                        updateState.windowId = info.windowId;
                    }                                        
                }else if(index === 1){ // for local files attachments
                	if(info.attachments.length>0){
            			this.assignLocalFiles(info.attachments);
            		}
                }else if(index === 2){ // for local files attachments
                	if(info.attachmentsInternal.length>0){
            			this.assignInternalFiles(info.attachmentsInternal);
                	}
                }else{ // metaidss
                    toUsersArr.push(info);
                }
                
            })
        }
        
        updateState.toUsers= toUsersArr;
        updateState.formFields['mail_subject'].value= mailData.subject;
        updateState.formFields['mail_body'].value= mailData.body;
        updateState.formFields['data_id'].value= mailData.id;
        updateState.triggerEffect = !this.state.triggerEffect;                
        this.setState(updateState); 
        setTimeout(() => { 
            this.templateListAPI();
            this.tagMappingList();
        	this.pdfCreationList(this.state.tableAttcahmentsRecords.pagination);
            this.toggleModelHandler(); 
        }, 500);
         
    }

    

    assignLocalFiles = (attachIds) => {
    	let fileIds = '';
        fileIds = attachIds.map( (a, i) => `&ids=${a = a.replace(/\s/g, '') }`).join('');
    	let APIURL = 'files/search?metatableId='+fileIds;
        callGET(APIURL)
        .then(response => {
            const responseData = response.data;
            if(responseData.code===200){
                let filesArr = [];
                if(responseData.data!==null){
                    responseData.data.map((fileItem, index) => {
                        filesArr.push({
                            id:fileItem.id,
                            value:fileItem.id,
                            checked:null,
                            file:fileItem,
                            label:fileItem.name,
                            size:fileItem.size
                        });       
                    });
                    this.setState({files:filesArr});
                }else{
                    this.setState({files:[]});
                }                    

            }else{
                this.setState({files:[]});
            }
        })
        .catch(err => {
            
        });	
    }

    assignInternalFiles = (attachIds) => {
    	let fileIds = '';
        fileIds = attachIds.map( (a, i) => `&ids=${a = a.replace(/\s/g, '') }`).join('');
    	let APIURL = 'files/search?metatableId='+fileIds;
        callGET(APIURL)
        .then(response => {
            const responseData = response.data;
            if(responseData.code===200){
                let filesArr = [];
                if(responseData.data!==null){
                    responseData.data.map((fileItem, index) => {
                        filesArr.push({
                            id:fileItem.id,
                            value:fileItem.id,
                            checked:null,
                            file:fileItem,
                            label:fileItem.name,
                            size:fileItem.size
                        });       
                    });
                    const totalSize = this.totalSizeHandler(this.state.files, filesArr, this.state.documentValue);
                    const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
                    this.setState({filesInternal:filesArr, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
                }else{
                    const totalSize =this.addSize(this.state.files);
                    const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
                    this.setState({filesInternal:[], totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
                }                    

            }else{
                this.setState({filesInternal:[]});
            }
        })
        .catch(err => {
            
        });	
    }

    /********** Draft section endss ***********/


    /**************** Table Modal PDF, CSV ****************/
    tableModalHandler = (attachType) => {
    	this.setState({attachType:attachType});

    	let formId = this.state.formId;
    	console.log(attachType,formId)
    	if(formId!==undefined && formId!==null && formId!==''){
    		if(attachType === 'DOCUMENT'){
    			this.toggleDirectory();	
    		}else if(attachType === 'PDF'){
    			this.callPDFAttachDirect();	
    		}else if(attachType === 'FILES'){
                    this.toggleFiles();
            }else{
    			this.chooseCsvTemplate('showModal');
    		}    		    		
    	}else{

    		const mail_to = this.state.toUsers;
	        let metaIds = [];
	        mail_to.map((toemail, index) => {	            
	            if(toemail.metatable_id!==''){
	                metaIds.push(toemail.metatable_id);
	            }	            
	        }) 
	        if(metaIds.length>0){
	        	if(attachType === 'DOCUMENT'){
    				this.toggleDirectory();	
    			}else if(attachType === 'PDF'){
	    			this.callPDFAttachDirect();	
	    		}else if(attachType === 'FILES'){
                    this.toggleFiles();
                } else {
                    this.attachInternalCSV();
                }
            }else {
                if (attachType === 'DOCUMENT') {
                    this.toggleDirectory();
                } else {
                    this.callWindowMetaData();
                }
            }    		
    	}    

    }


    callPDFAttachDirect = () => {
    	let updateState = { ...this.state }; 
    	if(!this.state.isModalOpen) {
            //updateState = this.clearTableModalFields(updateState);        	     
        }       
        updateState.isModalOpen = !this.state.isModalOpen;
        this.setState(updateState);
        this.pdfCreationList(this.state.tableAttcahmentsRecords.pagination);	
    }

    callWindowMetaData = () => {
    	let windowsListData = this.state.windowsListData;
    	let windowId = this.state.windowId;
    	let windowsListIndex = windowsListData.findIndex(item => item.id === windowId);
    	let windowName = windowsListData[windowsListIndex].display_name;
    	this.setState({windowNameMeta: windowName});
        setTimeout(() => {
            this.WindowMetaList(this.state.tableMetaRecords.pagination,true,windowName);	
        }, 10);
    }

    WindowMetaList = (pagination,loader=false) => {
    	const windowName = this.state.windowNameMeta;
    	if(windowName!==''){
    		const page = pagination.page; 
		    const orderBy = pagination.orderBy; 
		    const perPage = pagination.perPage; 
		    const direction = pagination.direction; 
		    const search = pagination.search;
		    this.setState({
		      tableMetaRecords:{
		        ...this.state.tableMetaRecords,
		        pagination:pagination
		      }
		    })
		    if(loader===true){ this.props.Loader(); }
		    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    		const listDataPromise = callPOST('table-data-engine/'+windowName+'/list/active'+queryString,{});
            const listCountPromise = callPOST('table-data-engine/'+windowName+'/listCount/active'+queryString,{});
            Promise.all([listCountPromise, listDataPromise])
            .then(([resCount, res]) => {
    		// .then(res => {
                console.log('resCount',resCount);
		      if(loader===true){ this.props.Loader(); }
		      if(res.status===200){ 
		        const response = res.data;
                const responseCount = resCount.data;
		        if(response.code===200){
		          const resData = response.data;
		          this.setState({lookup_layout:{
		            lookupLayoutId:resData.lookup_layout_id,
		            moduleId:resData.module_id,
		            windowId:resData.window_id,
		            windowName:windowName
		          }});
		          
		          let tablehead = [
		            {
		              name:'',
		              type:"Checkbox",
		              columnName:"",
		              isShow:true,
                      attributes:{style:{width: "30px"}},
                      changeHandler: this.selectDisplayedRowsHandler
		            }
		          ]
		          response.data.grid_list.map((header)=>{
		            tablehead.push({
		              name:header.display_name,
		              type:"HyperLink",
		              columnId:header.table_descriptor_id,
		              isShow:header.is_show,
		            });
		          }) 
		          let totalRecords = responseCount.data.value_list.total_elements;  
		          this.iterateAndSetTableData(tablehead,response.data.value_list.content,{
		            header:{
		              checked:false,
		              name:'windowCheckbox',
		              isShow:true,
                    //   changeHandler: this.onChangeSelectLookup
		            },
		            headerKey:'Checkbox'
		          },totalRecords,0);
		          // if(isEditPage===true){
		          //   this.setSelectedMultiLookupForUpdate(); 
		          // }else if(this.state.isConfirmPage===false){
		          //   this.checkWithSelectedMultiLookup();
		          // }
                  this.checkWithSelectedMultiLookup();
		          
		        }else{
		          const totalRecords = 0;//response.data.totalElements;
		          this.setState({status:200, tableMetaRecords:{
		            tableData:{data:[],status:400},
		            tableHead:this.state.tableMetaRecords.tableHead ,
		            pagination:{...this.state.tableMetaRecords.pagination,totalRecords:totalRecords}
		          },isModalMetaOpen:false});
		        }
		      }
		    }, (error) => {
		      console.log(error);
		      this.props.failMessage("Something went wrong...");
		      this.props.Loader(false);
		      
		    })	
    	}
	    	
    } 

    iterateAndSetTableData = (tablehead,content,headAction,totalRecords,isRefillOnEdit=0)=>{
      let updateTableData = [];
      let fieldsRow;
      content.map((contentData)=>{
        fieldsRow = {}
          fieldsRow = {
            ...fieldsRow,
            [headAction.headerKey]:{...headAction.header}
          };
          tablehead.map((column,headIndex)=>{
            if(headIndex>0){
              fieldsRow = {
                ...fieldsRow,
                [column.columnId]:{
                  className:'',
                  value:''
                },
              } 
            }
          });
          
        contentData.fieldGroups.map((section)=>{
          section.data.map((item,itemIndex)=>{
             const selectedItemValue = getSelectedValueBasedOnField(item);
                  fieldsRow = {
                      ...fieldsRow,
                      [item.id]:{
                          className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                          isDefaultDisplay:item.is_default_displayname,
                          value:(selectedItemValue!==undefined)?selectedItemValue:''
                      }
                  }
          })
        });
        const meta_table_id = (contentData.metaTableId)?contentData.metaTableId:contentData.meta_table_id
        updateTableData.push({
            clickHandler:this.onChangeSelectLookup.bind(this,meta_table_id),
            className:'',
            rowId:meta_table_id,
            data:fieldsRow
        })
      });
      this.setState({status:200, tableMetaRecords:{
        tableData:{data:updateTableData,status:200},
        tableHead:tablehead,
        pagination:{...this.state.tableMetaRecords.pagination,totalRecords:totalRecords}
      }, isModalMetaOpen:true});
      // if(isRefillOnEdit===1){
      //   this.props.setSelectedMultiLookup(updateTableData);
      //   setTimeout(() => {
      //     this.confirmSelectedMultiLookup(updateTableData,isRefillOnEdit);
      //   },100)
      // }
    }
    checkWithSelectedMultiLookup = (isconfirm=false)=>{
        const tableDataSel = this.state.tableMetaRecords;
          tableDataSel.tableData.data.map((item,index)=>{
            isSet(this.state.selectedMultiLookup,[]).map((selectedItem)=>{
                if(selectedItem===item.rowId){
                const tableData = tableDataSel.tableData.data[index].data;
                tableDataSel.tableData.data[index].className='selected';
                tableDataSel.tableData.data[index].isSelected=true;
                tableDataSel.tableData.data[index].data.Checkbox.checked=true;
                
                Object.entries(tableData).map(([key, column]) => {
                  if(Object.keys(isSet(column.item,{})).length>0){
                    tableDataSel.tableData.data[index].data[key] = selectedItem.data[key];
                  }
                })
                }
            })  
        })
        this.setState({status:200, tableMetaRecords:{...this.state.tableMetaRecords, tableDataSel}});
      }

    clearOrSelectAllRows = (boolean, selectedRows) => {
        const tableDataSel = this.state.tableMetaRecords;
        let metaTableData = this.state.selectedMultiLookup;
        isSet(tableDataSel.tableData.data, []).map((item, index) => {
            if (tableDataSel.tableData.data[index].data.Checkbox.checked === false && boolean === true) { console.log('jj');
                if (metaTableData.indexOf(item.rowId) !== -1) {
                } else {
                    tableDataSel.tableData.data[index].className='selected';
                    metaTableData.push(item.rowId);
                }
            }
            else if (!boolean)
            {
                metaTableData = metaTableData.filter(rowId => rowId !== item.rowId);
                tableDataSel.tableData.data[index].className='';
                console.log('mu ' , metaTableData);
            }
            tableDataSel.tableData.data[index].data.Checkbox.checked = boolean;
            this.onChangeSelectLookup(tableDataSel.tableData.data[index].data.Checkbox)
            
        });
        this.setState({ selectedMultiLookup: metaTableData });
    }
    selectDisplayedRowsHandler = (isSelect) => {
        console.log('isselect' ,this.state.tableMetaRecords);
        if (this.state.tableMetaRecords.tableHead.length > 0) {
            let selectedRows = this.state.tableMetaRecords;
            this.clearOrSelectAllRows((isSelect === 0) ? false : true, selectedRows);
        }
    }

    onChangeSelectLookup = (rowId,wthis,isFromState=0)=>{
      const tableDataSel = this.state.tableMetaRecords;
      let metaTableData = this.state.selectedMultiLookup;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          const columnId = tableDataSel.tableHead[1].columnName;
          let isChecked;
          isChecked = tableDataSel.tableData.data[index].data.Checkbox.checked;
          tableDataSel.tableData.data[index].className=(isChecked)? '':'selected';
          tableDataSel.tableData.data[index].isSelected=(isChecked)? false:true;
          tableDataSel.tableData.data[index].data.Checkbox.checked=(isChecked)? false:true;

          if(tableDataSel.tableData.data[index].data.Checkbox.checked){
              	//Add Redux state for selected Multilook rows
            	metaTableData.push(tableDataSel.tableData.data[index].rowId);
          }else{
              	//Remove Redux state for selected Multilook rows
            	metaTableData = metaTableData.filter((item,index)=>{
			        if(item!== rowId){
			          return item;
			        }
			    })
          }	
        }
      })
      this.setState({tableMetaRecords:{
        ...tableDataSel
      }, selectedMultiLookup: metaTableData})
    }

    cancelModalMetaHandler = () => {
    	this.setState({isModalMetaOpen:false});	
    }

    assignMetaData = () => {
    	this.cancelModalMetaHandler();
    	setTimeout(() => {
    		if(this.state.attachType === 'PDF'){
    			this.callPDFAttachDirect();	
    		}else if(this.state.attachType === 'FILES'){
                    this.getFilesList(this.state.selectedMultiLookup, this.state.windowId);
                    this.toggleFiles()
            }else{
    			this.chooseCsvTemplate();
    		}
            
        },500)
    	
    }

    clearTableModalFields = (updateState) => {
    	updateState.tableAttcahmentsRecords.selectedRows= [];
    	return updateState;
    }   

    radioOnChangeHandler = (descriptorId, index, isChecked) => {
        this.setState({tableAttcahmentsRecords:{
	        	selectedRows: []
	        }});
        const tableDataSel = this.state.tableAttcahmentsRecords;
        let selectedRows = tableDataSel.selectedRows;
        selectedRows = [];
        selectedRows.push(descriptorId);
        tableDataSel.tableData.data.map((item,index)=>{
        	if(item.rowId===descriptorId){
        		item.data.RadioButton.checked = true;
        	}else{
        		item.data.RadioButton.checked = false;
        	}
        })
        this.setState({tableAttcahmentsRecords:{
        		...tableDataSel,
	        	selectedRows: selectedRows
	        }});




      //   tableDataSel.tableData.data.map((item,index)=>{
      //   if(item.rowId===descriptorId){          
      //     if(!isChecked===true){
      //       let selectedRows = tableDataSel.selectedRows;
      //       selectedRows.push(descriptorId);
      //     }else{
      //       tableDataSel.selectedRows = tableDataSel.selectedRows.filter((selRows,selIndex)=>{
      //           if(descriptorId!== selRows){
      //               return selRows;
      //           }
      //       })
      //     }
          
      //   }
      // })

      // this.setState({tableAttcahmentsRecords:{
      //   ...tableDataSel,
      //   isSelectAll:false
      // }})
        
    }

    attachInternalPDF = () => {
    	let windowId = this.state.windowId;
    	let designId = this.state.tableAttcahmentsRecords.selectedRows;
    	if(designId.length>0){
    		this.props.Loader();
    		let htmlToPDFDesignId = designId[0];
        	const mail_to = this.state.toUsers;
	        let metaIds = [];
	        mail_to.map((toemail, index) => {	            
	            if(toemail.metatable_id!==''){
	                metaIds.push(toemail.metatable_id);
	            }	            
	        }) 

	        // scenerio 2: pdf click without to address, and got metadata from popup.
	        let selectedMultiLookup = this.state.selectedMultiLookup;
	        if(selectedMultiLookup.length>0){
	        	selectedMultiLookup.map((item, indes) => {
		        	metaIds.push(item);	
		        })	
	        }
	        

	        const body = {
		      ids : metaIds.length<1 ? [this.props.metaDataId] : metaIds
		    }
		    
			callPOST('data-convertor/'+windowId+'/htmlTopdf/attachPdf/'+htmlToPDFDesignId,body)
		    .then(response => {
		    	this.props.Loader();
		        const responseData = response.data;
		        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {

		          	let attachId = responseData.data;
		          	let APIURL = 'files/search?ids='+attachId;
			        callGET(APIURL)
			        .then(response => {
			            const responseData = response.data;
			            if(responseData.code===200){
			                let filesArr = this.state.filesInternal;
			                if(responseData.data!==null){
			                    responseData.data.map((fileItem, index) => {
			                        filesArr.push({
			                            id:fileItem.id,
			                            value:fileItem.id,
			                            checked:null,
			                            file:fileItem,
			                            label:fileItem.name,
			                            size:fileItem.size
			                        });       
			                    });
                                const totalSize = this.totalSizeHandler(this.state.files, filesArr, this.state.documentValue);
			                    const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
			                    this.setState({filesInternal:filesArr, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
			                }else{
			                    const totalSize =this.addSize(this.state.files);
			                    const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
			                    this.setState({filesInternal:[], totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
			                }

			                this.props.succMessage('Attached Successfully');

		            }else{
			                const totalSizeError =this.addSize(this.state.files);
			                const isExceeded = totalSizeError > FILE_SIZE_ATTACHMENTS_LIMIT;
			                this.setState({filesInternal:[], totalFileSize: totalSizeError, isFileSizeExceeded: isExceeded});
			                this.props.failMessage('Something went wrong!!!');
		            }

			            this.callPDFAttachDirect()                    			            
			        })
			        .catch(err => {
			            
			        });

		        }else {
		        	this.props.failMessage(responseData.message);
		        }
	      	}, (error) => {
	      		this.props.Loader();
	      		this.props.failMessage('Error occured!');
	          	console.log(error);
	      	})

    	}else{
    		this.props.failMessage("Please choose any one template.");	
    	}
    	

    }


    chooseCsvTemplate = (ss=null) => {
        const body = {
            window_id : this.state.windowId
        };
        const API_URL = "excel/templates/paginated-search/";
        http.POST(API_URL,body)
          .then(response => {
            const responseData = response.data;
            if(responseData.code===ShipConstants.API_STATUS_SUCCESS){
                const updateState = { ...this.state };
                updateState.excelTemplateList = [];
                updateState.isChooseExcelModelOpen = false;
                updateState.excelTemplateId ='';
                this.setState(updateState);
                if(responseData.data) {
                        const result = responseData.data.content.filter(content => content.default === true);
                        if(result.length === 0 && responseData.data.content.length !== 0) {
                            updateState['excelTemplateList'] = responseData.data.content;
                            updateState['isChooseExcelModelOpen'] = true;
                            updateState['excelTemplateId']='';
                        } else { 
                            if(result.length > 0) {
                                this.state.excelTemplateId = result[0].id;
                            }
                            this.attachInternalCSV(ss);
                        }
                    }
                this.setState(updateState);
            }
            }, (error) => {
              console.log(error);
              this.props.failMessage(error);
          })
      }
    toggleChooseExcelModel = () => {
        this.setState({'isChooseExcelModelOpen':!this.state.isChooseExcelModelOpen,existFormId:null});
      }
      chooseExcelTemplateChangeHandler = (e) => {
        const {name,value} = e.target;
        this.setState({'excelTemplateId':value});
      }

    attachInternalCSV = (ss=null) => {        
        if(ss===null){
            this.setState({'isChooseExcelModelOpen':!this.state.isChooseExcelModelOpen,existFormId:null});
        }
    	let windowId = this.state.windowId;
    	const mail_to = this.state.toUsers;
        let metaIds = [];
        mail_to.map((toemail, index) => {	            
            if(toemail.metatable_id!==''){
                metaIds.push(toemail.metatable_id);
            }	            
        }) 

        // scenerio 2: pdf click without to address, and got metadata from popup.
        let selectedMultiLookup = this.state.selectedMultiLookup;
        if(selectedMultiLookup.length>0){
        	selectedMultiLookup.map((item, indes) => {
	        	metaIds.push(item);	
	        })	
        }

        const body = {
	      ids : metaIds.length<1 ? [this.props.metaDataId] : metaIds
	    }
    	this.props.Loader();
    	callPOST('data-convertor/'+windowId+'/jsonTocsv/'+this.state.excelTemplateId+'',body)
	    .then(response => {
	    	this.props.Loader();
	        const responseData = response.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {

	          	let attachId = responseData.data;
	          	let APIURL = 'files/search?ids='+attachId;
		        callGET(APIURL)
		        .then(response => {
		            const responseData = response.data;
		            if(responseData.code===200){
		                let filesArr = this.state.filesInternal;
		                if(responseData.data!==null){
		                    responseData.data.map((fileItem, index) => {
		                        filesArr.push({
		                            id:fileItem.id,
		                            value:fileItem.id,
		                            checked:null,
		                            file:fileItem,
		                            label:fileItem.name,
		                            size:fileItem.size
		                        });       
		                    });
                            const totalSize = this.totalSizeHandler(this.state.files, filesArr, this.state.documentValue);
		                    const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
		                    this.setState({filesInternal:filesArr, totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
		                }else{
		                    const totalSize =this.addSize(this.state.files)
                            const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
		                    this.setState({filesInternal:[], totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
		                }

		                this.props.succMessage('Attached Successfully');

		            }else{
		                const totalSize =this.addSize(this.state.files);
		                this.setState({filesInternal:[], totalFileSize: totalSize});
		                this.props.failMessage('Something went wrong!!!');
		            }		                              			           
		        })
		        .catch(err => {
		            
		        });

	        }else {
	        	this.props.failMessage('To Address field missing!!!');
	        }
      	}, (error) => {
      		this.props.Loader();
      		this.props.failMessage('Error occured!');
          	console.log(error);
      	})

    }

    pdfCreationList = (pagination,loader=0) => {
	    const params = this.props.match.params;
	    const page = pagination.page; 
	    const orderBy = pagination.orderBy; 
	    const perPage = pagination.perPage; 
	    const direction = pagination.direction; 
	    const search = pagination.search;
	    this.setState({
	      tableAttcahmentsRecords:{
	        ...this.state.tableAttcahmentsRecords,
	        pagination:pagination
	      }
	    })
	    let windowId = this.state.windowId;
	    const queryString = windowId+'?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
	    callGET("htmltopdf-design/list/"+queryString)
	    .then(res => {
	      const response = res.data;
	      if(response.code===200){
	        let updateTableData = [];
	        let totalRecords = 0;
	        let pdflist = [];
	        if(response.data) {
	          updateTableData = response.data.content.map((item,index)=>{
                let isChecked = (this.state.tableAttcahmentsRecords.selectedRows.indexOf(item.id)!== -1)?true:false;

	            return {
	              className:'icon_hover cursor-pointer',
	              rowId:item.id,
	              clickHandler:this.radioOnChangeHandler.bind(this,item.id,index,isChecked),
	              data:{
	              	RadioButton:{
	                  checked: isChecked,
	                  name:'windowCheckbox',	                  
	                },
	                name:{
	                  value: item.design_name,
	                  //href:"/settings/"+params.windowName+"/"+params.windowId+"/edit-pdf-creation/"+item.id,
	                  href: "",
	                  //clickHandler:this.toggleHandler.bind(this,item.id),
	                  param:{
	                    data:{...item},
	                  },
	                  attributes:{
	                    id: item.id
	                    // is_editable: item.is_editable.toString(),
	                  },
	                  setting:{
	                  	actionMore:[{}]
	                  }
	                },
	                description:{
	                  value:item.description
	                },
	                is_active:{
	                  checked:item.is_active,
	                  attributes:{}
	                },
	                // html_content:{
	                //   value :item.html_content
	                // }
	                
	              }
	            }
	              
	          });
	          totalRecords = response.data.total_elements;
	          pdflist = response.data.content;
	        }
	        
	        this.setState({tableAttcahmentsRecords:{
	        	selectedRows: [],	
	          tableData:{data:updateTableData,status:200},
	          tableHead:this.state.tableAttcahmentsRecords.tableHead,
	          pagination:{...this.state.tableAttcahmentsRecords.pagination,totalRecords:totalRecords}
	        }});
	      }else{
	        const totalRecords = 0;//response.data.totalElements;
	        this.setState({tableAttcahmentsRecords:{
	          selectedRows: [],
	          tableData:[],
	          tableHead:this.state.tableAttcahmentsRecords.tableHead ,
	          pagination:{...this.state.tableAttcahmentsRecords.pagination,totalRecords:totalRecords}
	        }});
	      }
	    }, (error) => {
	      // this.props.failMessage("Something went wrong..");
	    })
	    .catch(err => {
	        console.log(err);
	    })
	}

	select2DataHandler = (value,name,optArr) => {                
       	const updateState = { ...this.state };        
	    updateState.formFields[name].value= value;
	    updateState.formFields[name].error= '';
	    updateState.autoFocusElement = 'subject'; 
	    if(name==='window_name' && (this.props.match.params.windowId===undefined || this.props.composePage === 'main')){
            updateState.windowId = value;   
        } 
        this.setState(updateState);   
	    if(name==='window_name'){
	        this.tagMappingList();
	    }  

    }

    stateChangeHandler = (e) => {
    	const {name,value} = e.target;
    	const updateState = {...this.state}
    	updateState[name] = value;
    	this.setState(updateState);
    }

callDocumentList =() => {
        const queryString = `&page=0&size=10&query=&orderBy=&direction=`;
        let APIURL = 'document/search?directory_only=true' + queryString;
        callGET(APIURL)                                     
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null){
                        this.setState({documentList:response.data});
                    }
                }
            }           

        },(error) => {
            console.log(error);
        })
    }

    toggleDirectory = () => {
    	this.setState({isDirectoryModalOpen:!this.state.isDirectoryModalOpen});
    }

    toggleFiles = () => {
    	this.setState({filesModalOpen:!this.state.isFilesModalOpen});
    }

    toggleFiles = () => {
    	this.setState({filesModalOpen:!this.state.isFilesModalOpen});
    }
    documentValueHandler = (val) => {
        const totalSize = this.totalSizeHandler(this.state.files, this.state.filesInternal, val);
        const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
        this.setState({documentValue:val,isDirectoryModalOpen:!this.state.isDirectoryModalOpen,totalFileSize: totalSize, isFileSizeExceeded: isExceeded});
    }
    
    getFilesList = (metaId1=null,windowId1=null) => {
        this.setState({isLoader:true})
        const params = this.props.match.params;
        const windowId = windowId1 ?? params.windowId
        // const metatableId = metaId1 ??( (this.props.metaDataId === undefined) ? null : this.props.metaDataId)
        let metaIdsStr = '';
        if (Array.isArray(metaId1) && metaId1.length > 0) {
            metaIdsStr = metaId1.join(',');
        } else if (this.props.metaDataId) {
            metaIdsStr = this.props.metaDataId; // single ID
        }
        let APIURL = 'files/search?windowId='+windowId+'&allFiles=true&metatableIds='+metaIdsStr;
        callGET(APIURL)
        .then(response => {
            this.setState({isLoader:false})
            const responseData = response.data;

            if(responseData.code===200){
                if(response.data!==null){
                    this.setState({filesList:response.data.data});
                    // this.toggleFiles();
                }

            }else{
                //this.props.succMessage(responseData.message);
            }
        })
        .catch(err => {
            this.setState({isLoader:false})
            if(err.response){
                this.props.failMessage(err.response.data.message);                
            }else {
                this.props.failMessage('Something went wrong');
            }
        }); 

    }

    toggleFiles = () => {
    	this.setState({isFilesModalOpen:!this.state.isFilesModalOpen});
    }

    filesValueHandler = (filesToAdd) => {
        if(filesToAdd && filesToAdd.length > 0) {
            const updatedFilesInternal = [...this.state.filesInternal, ...filesToAdd];
            const totalSize = this.totalSizeHandler(this.state.files, updatedFilesInternal, this.state.documentValue);
            const isExceeded = totalSize > FILE_SIZE_ATTACHMENTS_LIMIT;
            this.setState({
                filesInternal: updatedFilesInternal,
                isFilesModalOpen: !this.state.isFilesModalOpen,
                totalFileSize: totalSize,
                isFileSizeExceeded: isExceeded
            });
        } else {
            this.toggleFiles();
        }
    }


    /**************** Table Modal Endss ****************/

    render () {
    	const { toUsers, ccUsers, bccUsers, emailConfigList, windowNameMeta, selectedMultiLookup,documentValue,getAllUserList } = this.state;

    	const ModalTitle ="Choose Attachment";
        const modalType = 'tableList';
        const modalButtonList = [
          {
            attributes:{
              className:"btn btn btn-cancel mr-2",
              "data-dismiss":"modal",
              "id":"closeAddNewRoleModal",
            },
            clickHandler:this.callPDFAttachDirect,
            name:"Cancel"
          },
          {
            clickHandler:this.attachInternalPDF,
            type:'add',
            attributes:{
              "className":"btn primary_bg cursor-pointer",
            },
            name:"Attach"
          }
        ];
        const FooterButtonList = [];


        // Buttom list for metatable list data
        const ModalTitle1 ="Select "+windowNameMeta;        
        const modalButtonList1 = [
          {
            attributes:{
              className:"btn border-default btn-border mr-2",
              "data-dismiss":"modal",
              "id":"closeAddNewRoleModal",
            },
            clickHandler:this.cancelModalMetaHandler,
            name:"Cancel"
          },
          {
            clickHandler:this.assignMetaData,
            type:'add',
            attributes:{
              "className":"btn primary_bg cursor-pointer",
            },
            name:"Assign",
            disabled:(selectedMultiLookup.length>0)? false:true,
          }
        ];
        //console.log(documentValue);
    	return(
            <Wrp>
            	<NewMail 
                {...this.state}
                {...this.props}
                modelOpen={this.state.modal}
                totalFileSize={this.state.totalFileSize}
                isFileSizeExceeded={this.state.isFileSizeExceeded} 
                clickHandler={this.toggleModelHandler}
                ccToggleHandler={this.ccToggleHandler}
                bccToggleHandler={this.bccToggleHandler}
                mail_templates={this.state.mail_templates}
                callTemplateData={this.callTemplateData}
                formData={JSON.stringify(this.state.formFields)}
                addDataHandler={this.addDataHandler}
                addDataTemplateBody={this.addDataTemplateBody}
                saveDataHandler={this.saveDataHandler}
                searchUserHander={this.searchUserHander}
                ccSearchUserHander={this.ccSearchUserHander}
                bccSearchUserHander={this.bccSearchUserHander}
                handleOnBlur = {this.handleOnBlur}
                toInputValue={this.state.toInputValue}
                toUsers={toUsers}
                ccInputValue={this.state.ccInputValue}
                bccInputValue={this.state.bccInputValue}
                ccUsers={ccUsers}
                bccUsers={bccUsers}
                suggestions={this.state.suggestions}
                delimiters={delimiters}
                handleAddition={this.handleAddition}
                handleDelete={this.handleDelete}
                handleDeleteccUSer={this.handleDeleteccUSer}
                handleDeletebccUser={this.handleDeletebccUser}
                handleKeyDown={this.handleKeyDown}
                ccHandleKeyDown={this.ccHandleKeyDown}
                bccHandleKeyDown={this.bccHandleKeyDown}
                saveDraftHandler={this.saveDraftHandler}
                uploadMultipleFilesHandler={this.uploadMultipleFilesHandler}
                onFileChange={this.onFileChange}
                uploadFileAPICall={this.uploadFileAPICall}
                removeAddedFile={this.removeAddedFile}
                removeAddedFileInternal={this.removeAddedFileInternal}
                callDownloadImgFile={this.callDownloadImgFile}
                filterTemplateByTagHandler={this.filterTemplateByTagHandler}
                tableModalHandler={this.tableModalHandler}
                attachInternalCSV={this.attachInternalCSV}
                stateChangeHandler={this.stateChangeHandler}
                blurHandle={this.blurHandle}
                removeAddedFileDocument={this.removeAddedFileDocument}
                setIsFileSizeExceeded={this.setIsFileSizeExceeded}
                />

                {
                	this.state.replyToWindow === true?
                		<ReplyToMail 
		                	{...this.state}
		                	{...this.props}
		                	modelOpen={this.state.replyToWindow}
		                	clickHandler={this.toggleModelHandler}
			                ccToggleHandler={this.ccToggleHandler}
			                bccToggleHandler={this.bccToggleHandler}
			                mail_templates={this.state.mail_templates}
			                callTemplateData={this.callTemplateData}
			                formData={JSON.stringify(this.state.formFields)}
			                addDataHandler={this.addDataHandler}
			                addDataTemplateBody={this.addDataTemplateBody}
			                saveDataHandler={this.saveDataHandler}
			                searchUserHander={this.searchUserHander}
			                ccSearchUserHander={this.ccSearchUserHander}
			                bccSearchUserHander={this.bccSearchUserHander}
			                toInputValue={this.state.toInputValue}
			                toUsers={toUsers}
			                ccInputValue={this.state.ccInputValue}
			                bccInputValue={this.state.bccInputValue}
			                ccUsers={ccUsers}
			                bccUsers={bccUsers}
			                suggestions={this.state.suggestions}
			                delimiters={delimiters}
			                handleAddition={this.handleAddition}
			                handleDelete={this.handleDelete}
			                handleDeleteccUSer={this.handleDeleteccUSer}
			                handleDeletebccUser={this.handleDeletebccUser}
			                handleKeyDown={this.handleKeyDown}
			                ccHandleKeyDown={this.ccHandleKeyDown}
			                bccHandleKeyDown={this.bccHandleKeyDown}
			                saveDraftHandler={this.saveDraftHandler}
			                uploadMultipleFilesHandler={this.uploadMultipleFilesHandler}
			                onFileChange={this.onFileChange}
			                uploadFileAPICall={this.uploadFileAPICall}
			                removeAddedFile={this.removeAddedFile}
			                removeAddedFileInternal={this.removeAddedFileInternal}
			                callDownloadImgFile={this.callDownloadImgFile}
			                filterTemplateByTagHandler={this.filterTemplateByTagHandler}
			                tableModalHandler={this.tableModalHandler}
			                attachInternalCSV={this.attachInternalCSV} 
			                toggleReplyToWindow={this.toggleReplyToWindow}
			                stateChangeHandler={this.stateChangeHandler}
		                />
                	:
                	null
                }
                


                <AssignWindow 
                {...this.state}
                formData={JSON.stringify(this.state.formFields)}                 
                addDataHandler={this.addDataHandler}
                modelOpenWindow={this.state.modalWindow} 
                createTemplateHandler={this.continueHandler} 
                toggleModelHandlerWindow={this.toggleModelHandlerWindow} 
                select2DataHandler={this.select2DataHandler}
                />

                <TableModal 
                isModalOpen={this.state.isModalOpen}
              	title={ModalTitle}
              	modalType={modalType}
              	buttonList={modalButtonList}
              	tableRecords={this.state.tableAttcahmentsRecords}
              	FooterButtonList={FooterButtonList}
                selectedMultiLookupCount = {this.state.selectedMultiLookup.length}
              	recordsChangeHandler={this.pdfCreationList}
              	// selectedLookupCount = {this.props.selectedLookupCount.length}
              	//isConfirmPage={this.state.isConfirmPage}
                />

                <ChooseExcelTemplate
                currState={this.state}
                composePage={true}
                toggleChooseExcelModel={this.toggleChooseExcelModel}
                downloadCSVHandler={this.downloadCSVHandler}
                attachInternalCSV={this.attachInternalCSV}
                chooseExcelTemplateChangeHandler={this.chooseExcelTemplateChangeHandler}
                />

                <TableModalMeta 
                isModalOpen={this.state.isModalMetaOpen}
              	title={ModalTitle1}
              	modalType={modalType}
              	buttonList={modalButtonList1}
              	tableRecords={this.state.tableMetaRecords}
              	FooterButtonList={FooterButtonList}
              	recordsChangeHandler={this.WindowMetaList}
              	// selectedLookupCount = {this.props.selectedLookupCount.length}
              	//isConfirmPage={this.state.isConfirmPage}
                />

                <FileMapping
                	filesList={this.state.filesList}
                	isModalOpen={this.state.isFilesModalOpen}
                	toggleFiles={this.toggleFiles}
                	filesValueHandler={this.filesValueHandler}
                	filesInternal={this.state.filesInternal}
                    isLoader={this.state.isLoader}
                />

                <DirectoryMapping
                	documentList={this.state.documentList}
                	isModalOpen={this.state.isDirectoryModalOpen}
                	toggleDirectory={this.toggleDirectory}
                	documentValueHandler={this.documentValueHandler}
                	documentValue={documentValue}
                    Loader={this.props.Loader}
                />
            </Wrp>
        )
    }

}

const mapDispatchToProps = dispatch => {
    return {
      Loader : (bool) => dispatch(actions.loader(bool)),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))    
    };
  }
export default
    connect(
      null, 
      mapDispatchToProps
    )(withRouter(ComposeMailContainer));